// Svelte-free by design, so a `node:test` file can exercise it.

/**
 * Un solo indirizzo email, come lo accetta il gateway: `nome@dominio`, senza
 * nome visualizzato, senza elenchi e senza nulla che possa spezzare una riga.
 *
 * Copia speculare di normalizeEmailAddress() in src/email/address.js: il
 * frontend non può importare codice del backend, e
 * test/frontend-email-address.test.js tiene allineate le due versioni. Serve
 * a dire subito all'utente che l'indirizzo non va, invece di farlo scoprire
 * dalla risposta del server.
 */

const LOCAL = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
const DOMAIN = /^(?=.{1,253}$)[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;

/**
 * @param {unknown} value
 * @returns {string|null} l'indirizzo senza spazi ai lati, o null se non è esattamente un indirizzo valido
 */
export function normalizeEmailAddress(value) {
  if (typeof value !== 'string') return null;
  const text = value.trim();
  if (!text || text.length > 254) return null;
  const at = text.lastIndexOf('@');
  if (at <= 0 || text.indexOf('@') !== at) return null;
  const local = text.slice(0, at);
  const domain = text.slice(at + 1);
  if (local.length > 64 || !LOCAL.test(local) || !DOMAIN.test(domain)) return null;
  const tld = domain.slice(domain.lastIndexOf('.') + 1);
  if (!/^([A-Za-z]{2,63}|xn--[A-Za-z0-9-]{1,59})$/.test(tld)) return null;
  return text;
}

/** Vero quando il campo è vuoto (nessun indirizzo) oppure contiene un indirizzo valido. */
export function isEmptyOrValidEmail(value) {
  return !String(value ?? '').trim() || normalizeEmailAddress(value) !== null;
}
